

<div class="project">
	<div
		class="project-header"
		*rxLet="project$; let project" 
	>
		<h2	
		class="title"
	>
			{{ project.title }}
		</h2>
		
		<div [innerHtml]="project.body"></div>
	</div>

	<lib-thumbnails
		class="thumbnails"
		*rxLet="thumbnails$; let thumbnails"
		[thumbnails]="thumbnails"
		[index]="index$"
	></lib-thumbnails>
	
</div>

